module.exports = __webpack_public_path__ + "img/speed.382e1a8b.png";